import { Grid, Column } from '@carbon/react'
import { User, Activity, Analytics } from '@carbon/icons-react'
import {
  formatAnalyticsPercentOneDecimal,
  formatSuccessRatePercent,
} from '@sphere/shared/util'
import { MetricCard } from '../shared'
import styles from './EstablishmentAnalytics.module.scss'

export interface EstablishmentMetricsCardsProps {
  totalUsers: number
  totalClasses: number
  totalActivities: number
  totalAttempts: number
  avgScore: number | null
  passedAttempts: number
}

export function EstablishmentMetricsCards({
  totalUsers,
  totalClasses,
  totalActivities,
  totalAttempts,
  avgScore,
  passedAttempts,
}: EstablishmentMetricsCardsProps) {
  return (
    <Grid narrow className={styles.metricsGrid}>
      <Column lg={4} md={4} sm={4}>
        <MetricCard
          title="Élèves actifs"
          value={totalUsers}
          subtitle={`sur ${totalClasses} classes`}
          icon={User}
        />
      </Column>
      <Column lg={4} md={4} sm={4}>
        <MetricCard
          title="Activités uniques"
          value={totalActivities}
          subtitle={`${totalAttempts} tentatives`}
          icon={Activity}
        />
      </Column>
      <Column lg={4} md={4} sm={4}>
        <MetricCard
          title="Score moyen"
          value={formatAnalyticsPercentOneDecimal(avgScore)}
          subtitle="Établissement"
          icon={Analytics}
        />
      </Column>
      <Column lg={4} md={4} sm={4}>
        <MetricCard
          title="Taux de réussite"
          value={formatSuccessRatePercent(passedAttempts, totalAttempts)}
          subtitle={`${passedAttempts} réussies`}
          icon={Analytics}
        />
      </Column>
    </Grid>
  )
}
